import { render, staticRenderFns } from "./importCSVTraducoes.vue?vue&type=template&id=32c933d7&scoped=true&"
import script from "./importCSVTraducoes.vue?vue&type=script&lang=js&"
export * from "./importCSVTraducoes.vue?vue&type=script&lang=js&"
import style0 from "./importCSVTraducoes.vue?vue&type=style&index=0&id=32c933d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c933d7",
  null
  
)

export default component.exports